import { useEventCallback } from "@mui/material";
import { useCallback, useRef, useState } from "react";
import { useRevalidator } from "react-router-dom";

export function useRevalidatePolling(
  pollInterval: number,
  { maxAttempts, onError }: { maxAttempts: number; onError: () => void },
) {
  const { revalidate } = useRevalidator();
  const attempts = useRef(0);
  const [pollingStatus, setPollingStatus] = useState<"pending" | "stopped" | "maxAttempts" | "error">("stopped");
  const intervalRef = useRef<NodeJS.Timeout | null>(null);

  const onErrorCallback = useEventCallback(onError);
  const start = useCallback(() => {
    attempts.current = 0;
    setPollingStatus("pending");

    intervalRef.current = setInterval(() => {
      attempts.current += 1;

      if (attempts.current >= maxAttempts) {
        if (intervalRef.current) clearInterval(intervalRef.current);
        setPollingStatus("maxAttempts");
        onErrorCallback();
        return;
      }

      revalidate();
    }, pollInterval);
  }, [maxAttempts, onErrorCallback, pollInterval, revalidate]);

  const stop = useCallback(() => {
    if (intervalRef.current) clearInterval(intervalRef.current);
    setPollingStatus("stopped");
  }, []);

  return { pollingStatus, start, stop };
}
